import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminCityRequests = lazy(() => import("@/pages/admin/AdminCityRequests"));

export const Route = createFileRoute("/admin/city-requests")({
  component: AdminCityRequests,
});
